export const productOptionFragment = /* GraphQL */ `
  fragment productOption on CatalogProductOption {
    __typename
    entityId
    displayName
    isRequired
    ... on MultipleChoiceOption {
      displayStyle
      values(first: 50) {
        edges {
          node {
            entityId
            isDefault
            ... on SwatchOptionValue {
              hexColors
              imageUrl(width: 200)
              label
              isSelected
            }
            ... on MultipleChoiceOptionValue {
              entityId
              label
              isSelected
            }
            ... on ProductPickListOptionValue {
              entityId
              label
              isSelected
            }
          }
        }
      }
    }
    ... on NumberFieldOption {
      entityId
      displayName
    }
    ... on TextFieldOption {
      entityId
      displayName
    }
    ... on MultiLineTextFieldOption {
      entityId
      displayName
    }
    ... on FileUploadFieldOption {
      entityId
      displayName
    }
    ... on DateFieldOption {
      entityId
      displayName
    }
    ... on CheckboxOption {
      entityId
      displayName
    }
  }
`;

export const productVariantFragment = /* GraphQL */ `
  fragment productVariant on Variant {
    id
    entityId
    sku
    upc
    isPurchasable
    inventory {
      aggregated {
        availableToSell
      }
    }
    prices(includeTax: true) {
      price {
        value
        currencyCode
      }
      priceRange {
        min {
          value
          currencyCode
        }
        max {
          value
          currencyCode
        }
      }
    }
    options(first: 50) {
      edges {
        node {
          entityId
          displayName
          values(first: 50) {
            edges {
              node {
                entityId
                label
              }
            }
          }
        }
      }
    }
  }
`;

export const productFragment = /* GraphQL */ `
  fragment product on Product {
    id
    entityId
    sku
    upc
    name
    brand {
      name
    }
    plainTextDescription
    description
    availabilityV2 {
      status
      description
    }
    defaultImage {
      ...ImageFields
    }
    images {
      edges {
        node {
          ...ImageFields
        }
      }
    }
    seo {
      pageTitle
      metaDescription
      metaKeywords
    }
    path
    prices(includeTax: true) {
      price {
        ...MoneyFields
      }
      priceRange {
        min {
          ...MoneyFields
        }
        max {
          ...MoneyFields
        }
      }
    }
    createdAt {
      utc
    }
    variants(first: 250) {
      edges {
        node {
          ...productVariant
        }
      }
    }
    productOptions(first: 50) {
      edges {
        node {
          ...productOption
        }
      }
    }
    categories {
      edges {
        node {
          breadcrumbs(depth: 4) {
            edges {
              node {
                name
              }
            }
          }
        }
      }
    }
  }
  fragment ImageFields on Image {
    url: url(width: 1080)
    altText
  }
  fragment MoneyFields on Money {
    value
    currencyCode
  }
  ${productOptionFragment}
  ${productVariantFragment}
`;
